module.exports = __webpack_public_path__ + "static/media/logo-oeiras.1ee07e42.png";